import React from 'react';
import { Button } from '../../components/ui/Button';
import { CheckCircleIcon } from 'lucide-react';
export function HeroSection() {
  const credibilityPoints = ['Offices in Wixom & Kalamazoo, Michigan', 'Factory-trained service engineers', 'Used Wire & Sinker EDM expertise', 'Fast response for Michigan manufacturers'];
  return <section className="relative bg-gradient-to-br from-navy via-navy to-blue text-white py-10 md:py-14" data-id="element-2747">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2748">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-2749">
          {/* Left Column: Text Content */}
          <div data-id="element-2750">
            {/* Trust Badge */}
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6" data-id="element-2751">
              <span className="text-orange font-bold text-sm" data-id="element-2752">★</span>
              <span className="text-sm font-semibold" data-id="element-2753">
                Established 1995 • 30+ Years of Excellence
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4" data-id="element-2754">
              Peak Machine Sales
            </h1>

            <p className="text-xl md:text-2xl text-blue-100 mb-6 font-medium" data-id="element-2755">
              Michigan's Precision CNC Machine Dealer (Sales & Service Since
              1995)
            </p>

            <div className="mb-8" data-id="element-2756">
              <Button variant="primary" size="lg" href="59m7/used-machines.html" data-id="element-2757">
                Browse Used Inventory
              </Button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-6 border-t border-white/20" data-id="element-2758">
              {credibilityPoints.map((point, index) => <div key={index} className="flex items-start space-x-2" data-id="element-2759">
                  <CheckCircleIcon className="w-4 h-4 text-orange flex-shrink-0 mt-0.5" data-id="element-2760" />
                  <span className="text-blue-50 text-sm" data-id="element-2761">{point}</span>
                </div>)}
            </div>
          </div>

          {/* Right Column: Video */}
          <div className="hidden lg:block" data-id="element-2762">
            <div className="relative rounded-lg overflow-hidden shadow-xl aspect-video" data-id="element-2763">
              <iframe src="https://www.youtube.com/embed/oJcUj1e7Rnk" title="Peak Machine Sales Video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-2764" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}